import { MatChipsModule } from '@angular/material/chips';
import { FormsModule } from '@angular/forms';
import { ComingSoonComponent } from 'app/components/coming-soon/coming-soon.component';
import { TimestampPipe } from 'app/utils/pipes/timestamp';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CheckboxGroupDirective } from 'app/utils/checkbox-group.directive';
import { ReactiveFormsModule } from '@angular/forms';  // <-- #1 import module
import { I360LoaderModule } from 'app/utils/loader/loader.module';
import { I360TableModule } from 'app/utils/table/table.module';
import { I360ValidationModule } from 'app/utils/validator/validation.module';
import { RouterModule } from '@angular/router';
import { ModuleWithProviders, NgModule, Optional } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { InlineComponent } from 'app/utils/inline/inline.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CsfComponent } from 'app/utils/csf/csf.component';
import { I360LogWatcherModule } from 'app/components/settings/log-watcher/log-watcher.module';
import { EllipsisComponent } from 'app/utils/ellipsis.component';
import { ColoredIpComponent } from 'app/utils/colored-ip/colored-ip.component';
import { MatRippleModule } from '@angular/material/core';
import { I360ModalModule } from 'app/utils/modals/modal.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { I360NavigationTabsModule } from 'app/components/navigation-tabs/navigation-tabs.module';
import { AppComponent } from 'app/components/application/app.component';
import { I360TranslateModule } from 'app/utils/translate/translate.module';
import { I360WarningMessageModule } from 'app/utils/warning-message/warning-message.module';
import { I360CircleProgressModule } from 'app/utils/circle-progress/circle-progress.module';
import { I360RefresherModule } from 'app/utils/refresher/refresher.module';
import { MatIconModule } from '@angular/material/icon';
import { I360ClockModule } from 'app/utils/clock/clock.module';
import { I360MalwareModule } from 'app/components/i360-malware/i360-malware.module';
import { I360NavigationModule } from 'app/utils/navigation/navigation.module';
import { I360NotificationsModule } from 'app/components/notification/notifications.module';
import { I360SettingsModule } from 'app/components/settings/settings.module';
import { I360DescriptionModule } from 'app/utils/description/description.module';
import { I360ConfigModule } from 'app/utils/config/config.module';
import { angular18894CrutchProvider } from 'app/core/misc';
import { XHR } from 'app/utils/xhr/xhr';
import { SettingsService } from 'app/services/settings';
import { SessionExpiredInterceptor } from '../interceptors/session-expired.interceptor';
import { FileService } from 'app/services/file';
import { I360MenuProfileModule } from 'app/components/menu-profile/menu-profile.module';
import { BackupSystemsService } from 'app/services/backup-systems';
import { DemoInterceptor } from 'app/interceptors/demo.interceptor';
import { LicenseService } from 'app/services/license';
import { I360ButtonModule } from 'app/utils/button/button.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TextInputModule } from 'app/components/text-input/text-input.module';
import { I360ExperimentalModule } from 'app/utils/experimental/experimental.module';
import { I360LogBoxModule } from 'app/utils/log-box/log-box.module';
import { StatisticsService } from 'app/services/statistics';
import { I360AddItemModule } from '../utils/add-item/add-item.module';

const declarations = [
    ComingSoonComponent,
    TimestampPipe,
    CheckboxGroupDirective,
    InlineComponent,
    CsfComponent,
    ColoredIpComponent,
    // ExtendMatChipDirective,
    EllipsisComponent,
    AppComponent,
];

const modules = [
    MatRippleModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatRadioModule,
    MatProgressBarModule,
    RouterModule,
    CommonModule,
    MatSliderModule, // after BrowserModule, see https://github.com/angular/material2/issues/4278
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    I360AddItemModule,
    I360LoaderModule,
    I360TableModule,
    I360ValidationModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule,
    I360ModalModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatChipsModule,
    MatTooltipModule,
    I360TranslateModule,
    I360NavigationTabsModule,
    I360MalwareModule,
    I360LogWatcherModule,
    I360WarningMessageModule,
    I360CircleProgressModule,
    I360RefresherModule,
    I360ClockModule,
    I360NavigationModule,
    I360SettingsModule,
    I360DescriptionModule,
    I360ConfigModule,
    I360ExperimentalModule,
    I360MenuProfileModule,
    I360ButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TextInputModule,
    I360LogBoxModule,
];

@NgModule({
    exports: [
        I360NotificationsModule,
        ...declarations,
        ...modules,
    ],
    imports: [
        ...modules,
        I360NotificationsModule,
    ],
    declarations: declarations,
})
export class SharedModule {
    static forUser(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                angular18894CrutchProvider,
                SettingsService,
                XHR,
                FileService,
                BackupSystemsService,
                // LicenseService should be here to allow LicenseInterceptor
                // interrupt register request
                LicenseService,
                StatisticsService,
                { provide: HTTP_INTERCEPTORS, useClass: DemoInterceptor, multi: true},
                { provide: HTTP_INTERCEPTORS, useClass: SessionExpiredInterceptor, multi: true},
            ],
        };
    }
    // it is needed because service is not instantiated if there is no usage
    // optional - this service is declared in 'forUser' method, so will be present not
    // in all imports of shared module
    // this functionality is covered by tests
    constructor(
        @Optional() statistics: StatisticsService,
    ) {}
}
